import React from 'react';
import { Reveal } from './ui/Reveal';
import { SectionHeading } from './ui/SectionHeading';
import { Carousel } from './ui/Carousel';
import { proyectos } from '../data/landing';
export function ProyectosCarrusel() {
  return <section className="w-full bg-rosa-50 py-12 sm:py-20" aria-labelledby="proyectos-titulo" data-id="element-180" data-mp="3rkhecuq614f2">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-181" data-mp="g0wa7cv9lp6">
        <Reveal data-id="element-182" data-mp="5e2b2g39eyuu">
          <SectionHeading eyebrow="Resultados reales" title={<span id="proyectos-titulo" data-id="element-184" data-mp="5dsmmwxv4zr9">Mirá todo lo que podés crear</span>} data-id="element-183" data-mp="5ekj09zab1il" />
        </Reveal>
      </div>

      <Reveal delay={0.1} className="mt-8" data-id="element-185" data-mp="ab156ymxb5t1">
        <Carousel ariaLabel="Carrusel de proyectos terminados" data-id="element-186" data-mp="f3c7271851o8">
          {proyectos.map(proyecto => <figure key={proyecto.id} className="group relative h-full overflow-hidden rounded-3xl border-4 border-white shadow-suave" data-id="element-187" data-mp="j5z02b9mssn0">
              <div className="aspect-[4/5] w-full overflow-hidden bg-arena" data-id="element-188" data-mp="o5v7yllg947u">
                <img src={proyecto.imagen} alt={proyecto.titulo} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.05]" data-id="element-189" data-mp="t2tuoj2sa8w0" />
              </div>
              <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-borgona/85 to-transparent p-4 pt-12" data-id="element-190" data-mp="22nq2wowkwyp1">
                <span className="inline-block rounded-full bg-white px-3 py-1 font-sans text-[11px] font-bold uppercase tracking-[0.14em] text-frambuesa" data-id="element-191" data-mp="1ymxu1wrmcvta">
                  {proyecto.etiqueta}
                </span>
                <p className="mt-2 font-serif text-lg text-white sm:text-xl" data-id="element-192" data-mp="2qfoihl329g7z">
                  {proyecto.titulo}
                </p>
              </figcaption>
            </figure>)}
        </Carousel>
      </Reveal>
    </section>;
}